'use client';

import useSWR, { type SWRResponse } from 'swr';
import { usersApi, type UserProfile } from '@/lib/api';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

// The one shared cache for GET /users/me (VER-387). The profile is about to grow
// editable surfaces (consents, billing address) — writers revalidate this key so
// every reader agrees; ad-hoc fetches of the endpoint are being retired.
export function useProfile(): SWRResponse<UserProfile> {
  const authedFetch = useAuthedFetcher();

  return useSWR<UserProfile>(
    ['user-profile'],
    () => authedFetch((token) => usersApi.getMe(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
